import React from 'react'

const Profilesettings = () => {
  return (
    <div>Profilesettings</div>
  )
}

export default Profilesettings